function carouselNormalization() {
	var items = $(".carousel-normalize .carousel-item"), //grab all slides
		heights = [], //create empty array to store height values
		tallest; //create variable to make note of the tallest slide

	if (items.length) {
		function normalizeHeights() {
			items.each(function() {
				//add heights to array
				heights.push($(this).height());
			});
			tallest = Math.max.apply(null, heights); //cache largest value
			items.each(function() {
				$(this).css("min-height", tallest + 16 + "px");
			});
		}
		normalizeHeights();

		$(window).on("resize orientationchange", function() {
			(tallest = 0), (heights.length = 0); //reset vars
			items.each(function() {
				$(this).css("min-height", "0"); //reset min-height
			});
			normalizeHeights(); //run it again
		});
	}
}

$(document).ready(function() {
	carouselNormalization();

	$(".location-carousel").slick({
		dots: false,
		infinite: true,
		autoplay: false,
		autoplaySpeed: 2000,
		speed: 300,
		slidesToShow: 6,
		slidesToScroll: 2,
		arrows: true,
		responsive: [
			{
				breakpoint: 1440,
				settings: {
					arrows: true,
					slidesToShow: 5,
					slidesToScroll: 2,
					infinite: true
				}
			},
			{
				breakpoint: 1024,
				settings: {
					arrows: true,
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true
				}
			},
			{
				breakpoint: 600,
				settings: {
					arrows: true,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					arrows: true,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	$(".location-carousel").each(function() {
		let height = 0;
		$(this)
			.find(".location-carousel__location-title")
			.each(function() {
				if ($(this).height() > height) {
					height = $(this).height();
				}
			});

		$(this)
			.find(".location-carousel__location-title")
			.each(function() {
				$(this).height(height);
			});

		$(this)
			.find(".slick-next")
			.css("margin-top", height + "px");
		$(this)
			.find(".slick-prev")
			.css("margin-top", height + "px");
	});
});


// Products Carousel
$(document).ready(function() {
	carouselNormalization();

	$(".product-carousel").slick({
		dots: false,
		infinite: true,
		autoplay: false,
		autoplaySpeed: 2000,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		responsive: [
			{
				breakpoint: 1440,
				settings: {
					arrows: true,
					slidesToShow: 3,
					slidesToScroll: 2,
					infinite: true
				}
			},
			{
				breakpoint: 1024,
				settings: {
					arrows: true,
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true
				}
			},
			{
				breakpoint: 769,
				settings: {
					arrows: true,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					arrows: true,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	$(".product-carousel").each(function() {
		let height = 0;
		$(this)
			.find(".product-carousel__product-title")
			.each(function() {
				if ($(this).height() > height) {
					height = $(this).height();
				}
			});

		$(this)
			.find(".product-carousel__product-title")
			.each(function() {
				$(this).height(height);
			});

		$(this)
			.find(".slick-next")
			.css("margin-top", height + "px");
		$(this)
			.find(".slick-prev")
			.css("margin-top", height + "px");
	});

	$(".stepped-carousel .previous").on("click", function(event) {
		steppedCarouselPrev(event);
	});

	$(".stepped-carousel .next").on("click", function(event) {
		steppedCarouselNext(event);
	});

	function steppedCarouselNext(e) {
		let carousel = $(e.currentTarget).closest(".stepped-carousel");
		carousel.fadeOut(function() {
			carousel
				.find("article:first-of-type")
				.appendTo(carousel.find(".stepped-carousel__articles"));
			$(carousel).fadeIn();
		});
	}
	function steppedCarouselPrev(e) {
		let carousel = $(e.currentTarget).closest(".stepped-carousel");

		carousel.fadeOut(function() {
			carousel
				.find("article:last-of-type")
				.prependTo(carousel.find(".stepped-carousel__articles"));
			$(carousel).fadeIn();
		});
	}
});




//COLUMN CAROUSEL
$(function() {
	document.querySelectorAll('.column-carousel').forEach(el => {
		const cols = el.dataset.cols;
		let columns = [...el.querySelectorAll('.column-carousel-item')];
		const prev = el.querySelector('.previous');
		const next = el.querySelector('.next');

		prev.addEventListener('click', _ => {
			// Copy element from end of the list to the start
			columns[0].parentNode.insertBefore(columns[columns.length - 1].cloneNode(true), columns[0]);
			// Remove old element
			columns[0].parentNode.removeChild(columns[columns.length - 1]);
			columns = [...el.querySelectorAll('.column-carousel-item')];
		});

		next.addEventListener('click', _ => {
			// Copy element from the start of the list to the end
			columns[0].parentNode.appendChild(columns[0].cloneNode(true));
			// Remove old element
			columns[0].parentNode.removeChild(columns[0]);
			columns = [...el.querySelectorAll('.column-carousel-item')];
		});

		// Create stylesheet that applies only to this carousel
		const style = document.createElement('style');
		style.innerHTML = `#${el.id} .column-carousel-item {
            display: none;
        }`;
		style.innerHTML += Array.from({length: cols}, (_, i) => `#${el.id} .column-carousel-item:nth-of-type(${i + 1})`).join(',');
		style.innerHTML += `{
            display: block;
        }`;
		el.appendChild(style);

		// Autoplay
		if (!window[el.id]) window[el.id] = {};
		window[el.id].autoplayStart = _ => {
			window[el.id].__autoplay = setInterval(function() {
				if (el.dataset.autoplay) {
					next.click();
				}
			}, 1000 * 10);
		};
		window[el.id].autoplayStop = _ => {
			clearInterval(window[el.id].__autoplay);
		}

		window[el.id].autoplayStart();
	});
});

//VIDEO CAROUSEL
$(document).ready(function() {
	carouselNormalization();
	let cols = $(".video-carousel").data('cols');
	$(".video-carousel").slick({
		dots: false,
		infinite: true,
		autoplay: false,
		autoplaySpeed: 2000,
		speed: 300,
		slidesToShow: cols,
		slidesToScroll: 1,
		arrows: true,
		responsive: [
			{
				breakpoint: 1920,
				settings: {
					arrows: true,
					slidesToShow: cols,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 1440,
				settings: {
					arrows: true,
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 1024,
				settings: {
					arrows: true,
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 600,
				settings: {
					arrows: true,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					arrows: true,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	}).on('setPosition', function (event, slick) {
		slick.$slides.css('height', slick.$slideTrack.height() + 'px');
	});

	$(".video-carousel").each(function() {
		let height = 0;
		$(this)
			.find(".videos-carousel-title")
			.each(function() {
				if ($(this).height() > height) {
					height = $(this).height();
				}
			});

		$(this)
			.find(".videos-carousel-title")
			.each(function() {
				$(this).height(height);
			});

		$(this)
			.find(".slick-next")
			.css("margin-top", height + "px");
		$(this)
			.find(".slick-prev")
			.css("margin-top", height + "px");
	});
});